import "./TodosEmpty.css";

function TodosEmpty() {
  return <p className='Todos-empty'>Crea tu primer tarea!!!</p>;
}

export { TodosEmpty };
